enum XMLHttpRequestReadyStateEnum {
	unsent = 0,
	opened = 1,
	headersRecieved = 2,
	loading = 3,
	done = 4
}

export default XMLHttpRequestReadyStateEnum;
